import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  /**
   * Returns the API URL with the appropriate prefix for proxying
   * @param endpoint The API endpoint path (without leading slash)
   * @returns The full URL to use for API requests
   */
  getUrl(endpoint: string): string {
    // Always use /api/ prefix - nginx will proxy to the appropriate backend
    // This avoids CORS issues by making same-origin requests
    return `/api/${endpoint}`;
  }
}
